import { computed, inject, Injectable, signal } from '@angular/core';
import { EngagementGridContainerPage, EngagementType, StaffRoleId } from '@interfaces';
// import { ExperienceFollowUpsCommonService } from '../../../services';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { ExperienceAreaService } from '../experience-area.service';


/**
 * The list of tabs on this page
 */
export enum ExperienceEngagementsPageTabId {
	Tab1 = 1,
	Tab2 = 2,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ExperienceEngagementsPageViewId {
	ContactReqs = 1,
	OpenEngagements = 2,
	CompletedEngagements = 3,
	FollowUps = 4,
}


@Injectable({ providedIn: 'root' })
export class ExperienceEngagementsService extends PageTabsLayoutPageService<ExperienceEngagementsPageTabId, ExperienceEngagementsPageViewId> {

	public readonly areaService = inject(ExperienceAreaService);
	public engagements = computed(() => this.areaService.experienceData()?.engagements || []);
	public followUps = computed(() => this.areaService.experienceData()?.followUps || []);
	public contactRequests = computed(() => this.areaService.experienceData()?.contactRequests || []);
	public readonly page = signal<EngagementGridContainerPage>(EngagementGridContainerPage.Experience);
	public engagementType = signal<EngagementType | undefined>(undefined);
	public readonly staffRoleId = signal<StaffRoleId | undefined>(StaffRoleId.ProgramExperience);

	private static readonly _viewDroplistItems: DroplistItem<never, ExperienceEngagementsPageViewId>[] = [
		{
			uniqueId: ExperienceEngagementsPageViewId.ContactReqs, iconContext: {
				iconClass: 'fa-envelope-dot',
				iconStyle: 'fa-solid',
				text: 'Contact Requests',
				hideText: 'never',
			},
			customSort: '1-Views-1'
		},
		{
			uniqueId: ExperienceEngagementsPageViewId.OpenEngagements, iconContext: {
				iconClass: 'fa-message-arrow-up-right',
				iconStyle: 'fa-solid',
				text: 'Open Engagements',
				hideText: 'never',
			}, customSort: '1-Views-2'
		},
		{
			uniqueId: ExperienceEngagementsPageViewId.CompletedEngagements, iconContext: {
				iconClass: 'fa-message-check',
				iconStyle: 'fa-solid',
				text: 'Completed Engagements',
				hideText: 'never',
			},
			customSort: '1-Views-3'
		},
		{
			uniqueId: ExperienceEngagementsPageViewId.FollowUps, iconContext: {
				iconClass: 'fa-reply-clock',
				iconStyle: 'fa-solid',
				text: 'Scheduled Follow Ups',
				hideText: 'never',
			},
			customSort: '1-Views-4'
		},
	];

	constructor() {
		super(ExperienceEngagementsService._viewDroplistItems, ExperienceEngagementsService.name, ExperienceEngagementsPageTabId.Tab1, ExperienceEngagementsPageViewId.OpenEngagements);
	}

	public get viewId() {
		return ExperienceEngagementsPageViewId;
	}


	async reloadData() {
		await this.areaService.reloadData();
	}
}
